$(function () {
    var calendar_container = $('.calendar');
    var calendar = $('#calendar');
    var modal = $('#calendar-modal');
    var modal__target = modal.find('[data-target]');
    var modal__target_item = modal.find('[data-target-item]').clone().children().remove().end();
    var today = moment();
    var viewRange = {
        start: today.clone().startOf('year'),
        end: today.clone().endOf('year'),
    };
    var months_fetched = {};

    var data = {};

    function dayClicked(date) {
        if (!dayHasData(date)) return;
        if (modal.data('day') == date.dayOfYear()) return modal.modal('show');
        modal__target.empty();
        modal.find('.modal-title').text(date.format('D MMMM'));
        data[date.dayOfYear()].forEach(function (el) {
            modal__target_item.clone().html(el).appendTo(modal__target);
        });
        modal.data('day', date.dayOfYear());
        modal.modal('show');
    }

    function changeView() {
        var direction = $(this).data('direction');
        var current_month = calendar.fullCalendar('getDate').startOf('month');
        var next_month = (direction == 'next') ? current_month.add(1, 'M') : current_month.subtract(1, 'M');
        if (next_month < viewRange.start || next_month > viewRange.end) return;
        var ready = $.Deferred().resolve();

        if (!monthHasData(next_month)) {
            startLoading();
            ready = fetchData(next_month);
        }

        ready.done(function () {
            calendar.fullCalendar(direction);
            updateTitle();
            endLoading();
        });
    }

    function dayRender(date, cell) {
        var container = $('<div class="day-content"><div class="day-number">' + date.format('D') + '</div></div>');
        cell.append(container);

        if (dayHasData(date))
            cell.addClass('has-data');
        return cell;
    }

    function dayHasData(date) {
        return data.hasOwnProperty(date.dayOfYear());
    }

    function monthHasData(date) {
        // var start_day = date.startOf('month').dayOfYear();
        // var end_day = date.endOf('month').dayOfYear();
        // for (var day in data) {
        //     if (start_day <= parseInt(day) && parseInt(day) <= end_day) {
        //         return true;
        //     }
        // }
        return months_fetched.hasOwnProperty(date.month()) && months_fetched[date.month()];
    }

    function setfetchedMonth(month) {
        months_fetched[month] = true;
    }

    function dayHasEvents(day) {
        return data[day] != null;
    }

    function updateTitle() {
        $('.calendar__header .calendar__title').text(calendar.fullCalendar('getDate').format('MMMM Y'));
    }

    function startLoading() {
        calendar_container.addClass('fetching');
    }

    function endLoading() {
        calendar_container.removeClass('fetching');
    }

    function fetchData(date) {
        var params = {};
        if (date !== undefined) {
            params.month = date.format('M');
            params.year = date.format('Y');
        }


        return $.get(calendar.data('href'), params).then(function (response) {
            if (response.start_date)
                setfetchedMonth(moment(response.start_date).month());
            // console.dir(response);
            if (response.status == 404 || response.data === null) {
                return false;
            }
            console.dir(response);
            $.extend(data, response.data);
            return true;
        }, function (reject) {
            console.error('Calendar fetch error', reject);
        });
    }

    function init() {

        calendar.fullCalendar({
            locale: 'it',
            height: 'auto',
            // aspectRatio: 1,
            // contentHeight: 'auto',
            header: false,
            dayRender: dayRender,
            dayClick: dayClicked,
            dayNamesShort: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
        });

        $('.calendar__header').find('.prev, .next').click(changeView);
        updateTitle();

        return $.Deferred().resolve();
    }

    startLoading();
    fetchData().always(init).then(endLoading);


});